import React from 'react';

const ProductWarningText = ({ product }) => {
    if (!product && (!product?.tags || !product.productWarningValue)) return null;

    const isLongHair = product?.tags?.filter((tag) =>
        tag === "Show long hair warning").length > 0;
    const longHairWarning = window.LongHairWarning?.text;
    const metaWarning = product.productWarningValue?.value;

    if (!isLongHair && !metaWarning) return null;

    return (
        <div className="long-hair-warning">
            <span>!</span>
            <div
                dangerouslySetInnerHTML={
                    {
                        __html: metaWarning
                            ? `<p>${metaWarning}</p>`
                            : longHairWarning
                    }
                }
            />
        </div>
    )
};

export default ProductWarningText;
